import * as Sentry from "@sentry/angular";
import { ApplicationConfig, ErrorHandler, provideAppInitializer, inject } from '@angular/core';
import { RouteReuseStrategy, Router } from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';
import { environment } from '../environments/environment';
import { provideFirebase } from './app.config.firebase';
import { appRouting } from './app.routes';
import { provideAppStore } from 'src/app/core/store/app.provider';

import { LogLevel, setLogLevel } from '@angular/fire';
setLogLevel(LogLevel.VERBOSE);

export const appConfig: ApplicationConfig = {
  providers: [
    appRouting,
    provideAppStore(environment),
    provideIonicAngular(),
    provideFirebase(environment),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    })
  ],
};